/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const buildDefaultGlobalCommandIntelligenceConfig = ({ agentRef } = {}) => {
  const resolvedAgentRef = agentRef || 'warehouse-analyst';

  return {
    drawerTitleStringId: 'command_intelligence_drawer_title',
    profiles: [
      {
        id: resolvedAgentRef,
        labelStringId: 'command_intelligence_profile_agent',
      },
    ],
    getPreset: (mode, profile) => ({
      mode,
      profile,
      agentRef: profile || resolvedAgentRef,
      channelNameId: 'command_intelligence_drawer_title',
      headlineId: 'command_intelligence_drawer_title',
      subheadId: 'command_intelligence_attach_hint',
      suggestionItems: [],
    }),
    buildAttachedContext: () => ({}),
    getFeaturedSuggestions: () => [],
  };
};
